// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wp-edit-link":"zSIwi7"};